class SidebarDrawer extends HTMLElement {
    constructor(){
        super();
        this.querySelector('[data-js-close]')?.addEventListener('click', ()=>{
            this.hide();
        });
        document.addEventListener('keydown', e=>{
            if ( e.keyCode == window.KEYCODES.ESC ) {
                const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
                if ( openedSidebar ){
                    openedSidebar.hide();
                }
            }
        });        
    }

    show(){
        this.opened = true;
        if (this.classList.contains('sidebar--right')) {
            document.body.classList.add('sidebar-opened--right');
        } else if (this.classList.contains('sidebar--left')) {
            document.body.classList.add('sidebar-opened--left');
        }
        setTimeout(()=>{
            this.classList.add('sidebar--opened');
        }, 15);
        if (this.id == "site-cart-sidebar") {
            if (typeof window.cartRecommendation != 'undefined') window.cartRecommendation();
        }
        document.body.classList.add('overlay-hidden');
    }

    hide() {
        this.opened = false;
        this.classList.remove('sidebar--opened');

        document.body.classList.remove('sidebar-opened--left');
        document.body.classList.remove('sidebar-opened--right');
        document.querySelector(`[aria-controls="${this.id}"]`).setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overlay-hidden');
    }

}

if (typeof customElements.get('sidebar-drawer') == 'undefined') {
    customElements.define('sidebar-drawer', SidebarDrawer);
}

const debounce = (fn, wait) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

document.addEventListener("DOMContentLoaded", function () {
    let mouseDownTarget = null;

    // Helper to get opened sidebar
    const getOpenedSidebar = () => document.querySelector('.sidebar--opened');

    // Track where mouse started (for smarter click outside detection)
    document.addEventListener('mousedown', e => {
        mouseDownTarget = e.target;
    });

    // Click handler delegation
    document.addEventListener('click', e => {
        const sidebarHandle = e.target.closest('[data-js-sidebar-handle]');
        if (sidebarHandle && sidebarHandle.hasAttribute('aria-controls')) {
            e.preventDefault();
            const sidebar = document.getElementById(sidebarHandle.getAttribute('aria-controls'));
            sidebarHandle.setAttribute('aria-expanded', 'true');
            sidebar.show();
            return;
        }

        const closeBtn = e.target.closest('sidebar-drawer [data-js-close]');
        if (closeBtn) {
            e.preventDefault();
            const sidebar = closeBtn.closest('.sidebar');
            if (sidebar && sidebar.classList.contains('sidebar--opened')) {
                sidebar.hide();
            }
            return;
        }

        if (e.target.matches('.drawer-overlay')) {
            const openedSidebar = getOpenedSidebar();
            if (openedSidebar) openedSidebar.hide();
            return;
        }

        // Only close if mouseDown AND click are both outside sidebar and handle
        const openedSidebar = getOpenedSidebar();
        if (
            openedSidebar &&
            !openedSidebar.contains(mouseDownTarget) &&
            !mouseDownTarget?.closest('[data-js-sidebar-handle]') &&
            !openedSidebar.contains(e.target) &&
            !e.target.closest('[data-js-sidebar-handle]')
        ) {
            openedSidebar.hide();
        }
    });

    document.addEventListener('keyup', e => {
        if (e.keyCode !== window.KEYCODES.RETURN) return;
        const sidebarHandle = e.target.closest('[data-js-sidebar-handle]');
        if (sidebarHandle && sidebarHandle.hasAttribute('aria-controls')) {
            const sidebar = document.getElementById(sidebarHandle.getAttribute('aria-controls'));
            sidebarHandle.setAttribute('aria-expanded', 'true');
            sidebar.show();
            sidebar.querySelector('[data-js-close]').focus();
        }
    });

    document.addEventListener('keydown', e => {
        if (e.keyCode === window.KEYCODES.ESC) {
            const openedSidebar = getOpenedSidebar();
            if (openedSidebar) openedSidebar.hide();
        }
    });
});
